import { render } from "./RandomImage.vue?vue&type=template&id=3767851f&scoped=true"
import script from "./RandomImage.vue?vue&type=script&lang=js"
export * from "./RandomImage.vue?vue&type=script&lang=js"

import "./RandomImage.vue?vue&type=style&index=0&id=3767851f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3767851f"]])

export default __exports__